
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Paragraph } from '@ecl/website-components';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Paragraph size="lead" mdxType="Paragraph">
  The following digital design principles{' '}
  <strong>guide and influence our design decisions</strong> and serve as our
  solutions' foundation. They do not merely ensure consistency but they help us
  to <strong>convey the European Union vision and values</strong> while
  supporting the User Experience and they iteratively evolve as we make new
  findings.
    </Paragraph>
    <div style={{
      borderLeft: '4px solid #0E47CB',
      marginTop: '3rem',
      paddingLeft: '1rem'
    }}>
      <h2>{`Connecting with people`}</h2>
      <p><strong parentName="p">{`We design for people`}</strong>{`, because there's more to people than just interaction with technology. Through empathy, we create authentic connections with human beings, helping them with their digital journey and `}<strong parentName="p">{`enabling happiness`}</strong>{`.`}</p>
    </div>
    <div style={{
      borderLeft: '4px solid #00C991',
      marginTop: '3rem',
      paddingLeft: '1rem'
    }}>
      <h2>{`Intuitive and straightforward`}</h2>
      <p>{`Design is like an ongoing two-way conversation. Familiarity and clarity enhance this conversation, making it `}<strong parentName="p">{`effective, easy to understand`}</strong>{` and `}<strong parentName="p">{`personal`}</strong>{`.`}</p>
    </div>
    <div style={{
      borderLeft: '4px solid #510DCD',
      marginTop: '3rem',
      paddingLeft: '1rem'
    }}>
      <h2>{`Inspiring trust and engagement`}</h2>
      <p>{`Design helps to create branding and organisation trust. It conveys a positive sense of `}<strong parentName="p">{`transparency, openness`}</strong>{` and `}<strong parentName="p">{`modernity`}</strong>{`, and builds future engagement.`}</p>
    </div>
    <div style={{
      borderLeft: '4px solid #EF0044',
      marginTop: '3rem',
      paddingLeft: '1rem'
    }}>
      <h2>{`Relevant, effective and concise`}</h2>
      <p>{`We promote `}<strong parentName="p">{`quality over quantity`}</strong>{`. We deliver exactly what is needed to satisfy our visitors' expectations and enhance our credibility as an official and trusted source.`}</p>
    </div>
    <div style={{
      borderLeft: '4px solid #FF6200',
      marginTop: '3rem',
      paddingLeft: '1rem'
    }}>
      <h2>{`Inclusive and accessible`}</h2>
      <p>{`Our design reflects the values of the European way of life, but without compromising the quality or aesthetic of the website.`}</p>
    </div>
    <div style={{
      borderLeft: '4px solid #FFCC00',
      marginTop: '3rem',
      paddingLeft: '1rem'
    }}>
      <h2>{`Long-lasting and evolving`}</h2>
      <p>{`We think outside the boundary of a website's homepage. We embrace `}<strong parentName="p">{`social changes`}</strong>{` and `}<strong parentName="p">{`future thinking`}</strong>{`, reframing problems and solutions beyond fashionable appeal.`}</p>
    </div>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;